<div class="sidebar">
	<app-sidebar-header [title]="'Internet Wi-Fi onboard'" [label]="'20 ' + currency.symbol +' per item'">
		<div actions><button class="button button--small" (click)="TAP_handleDone()" aria-label="Confirm changes"
				*ngIf="TAP_hasAddedVouchers()">Done</button></div>
	</app-sidebar-header>

	<div class="sidebar__body sl--scrollable" #sidebar__body>
		<app-flight-route [flight]="flight"></app-flight-route>
		<div class="sidebar__header-image"
			[style.background-image]="'url(assets/images/ancillaries/includes/wifi-onboard.jpg)'"></div>
		<div #sidebar__info class="sidebar__info sidebar__info--columns">
			<div class="sidebar__info-text">
				<ul class="vantages-listing">
					<li>Even when up in the clouds, you can access the Internet and travel to other worlds.</li>
					<li>Free Messaging</li>
					<li>Complete cost control</li>
					<li>A number of payment options are available – credit card, PayPal, iPass, etc.</li>
					<li>Different packages available according to your needs.</li>
				</ul>
			</div>
			<!-- <div class="partner-info">
				<p class="muted">in partnership with</p>
				<app-svg svg="sprite.svg#partners--panasonic" [alt]="'Panasonic logo'"></app-svg>
			</div> -->
		</div>
		<div class="flight">
			<div class="passenger" *ngFor="let passenger of passengers; let passenger_index = index">
				<div class="passenger__details">
					<h3 class="title-h3 passenger__name">
						{{TAP_printPassengerName(passenger)}}
					</h3>
				</div>
				<div class="passenger__actions">

					<div class="passenger__action" *ngFor="let voucher of passenger.stops[0].added?.wifi">
						<article class="ancillary-info-added-extra">
							<app-svg class="ancillary-info-added-extra__icon" svg="icons.svg#general--check" [alt]="'Added icon'">
							</app-svg>
							<div class="ancillary-info-added-extra__info">
								<h4 class="ancillary-info-added-extra__title"><span class="bold">{{ voucher.name }}</span> — added</h4>
								<span class="ancillary-info-added-extra__label">Voucher number</span>
								<p class="ancillary-info-added-extra__value" [tooltip]="'Copy number to clipboard'"
									[appCopyClipboard]="'UTWU-305-945-999'">UTWU-305-945-999</p>
							</div>
						</article>
					</div>

					<div class="passenger__action" *ngFor="let voucher of passenger.stops[0].wifi">
						<button class="button button-secondary button--icon-right"
							(click)="TAP_handleRemoveVoucher(passenger_index)" role="alert" aria-label="Pack 400MB added">
							{{ voucher.name }} added<app-svg svg="icons.svg#general--check" [alt]="'Added icon'"></app-svg>
							<span class="extra-price"> ({{TAP_printVoucherPrice(voucher)}})</span>
						</button>
						<app-svg [ngClass]="['remove-extra']" aria-label="Remove voucher"
							(click)="TAP_handleRemoveVoucher(passenger_index)" svg="icons.svg#general--close" [alt]="'Remove icon'"
							tabindex="0"></app-svg>
					</div>

					<div class="passenger__action">
						<form [formGroup]="form" *ngIf="this.formsPerPassenger[passenger_index] as form" class="passenger__action">
							<div class="select-wrapper">
								<app-select-input [id]="'p'+passenger_index" (change)="TAP_handleAddVoucher(passenger_index)"
									[parentForm]="form" formControlName="wifiAdd"
									[placeholder]="(!form.get('wifiAdd').value) ? 'Add Internet pack' : null" [inputOptions]="options">
								</app-select-input>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
		<div class="extras__helper with-notification" *ngIf="TAP_hasNextFlight() || notificationShowing">
			<div class="extras__helper-actionable" *ngIf="TAP_hasNextFlight()">
				<a class="link" (click)="copyToOtherFlights()" title="Apply your chosen extras to all the remaining flights"
					href="javascript:;" role="button">Apply the same for the other
					flights</a>
			</div>
			<div #sidebar__notification class="extras__helper-notification" role="status" tabindex="0"
				[class.is-showing]="notificationShowing" [attr.aria-hidden]="!notificationShowing">
				{{ notificationMessage }}
			</div>
		</div>
		<div class="sidebar__payment_totals">
			<div class="total" *ngIf="TAP_hasAddedVouchers()">
				<label class="label">{{ TAP_printItemsCount() }} items</label>
				<p class="value">{{TAP_printTotal()}}</p>
			</div>

			<div class="flow_actions" *ngIf="TAP_hasAddedVouchers()">
				<app-flights-navigation></app-flights-navigation>
			</div>
			<div class="flow_actions" [ngClass]="TAP_flowActionsClasses()" *ngIf="TAP_hasAddedVouchers()">
				<button class="button" (click)="TAP_handleDone()" aria-label="Confirm added Bags and close Dialog">Done</button>
			</div>
		</div>
		<div class="sidebar-flight-text top-gap">
			<p>We recommend that automatic download settings and updates be disabled on your device to minimise data use.</p>
		</div>
		<div class="conditions">
			<h3 class="title-h3 conditions__title">Conditions</h3>
			<div class="conditions__text">
				<div class="grid">
					<div class="col-12">
						<ul class="bullet-list">
							<li>Not transferable</li>
							<li>Not changeable</li>
							<li>Available for flights operated by TAP / TAP Express</li>
						</ul>
					</div>
				</div>
			</div>
			<a class="link link--external" href="{{'externalURLs.wifiTermsConditions' | ibeadmincfg }}">All terms and conditions</a>
		</div>
	</div>
	<div #sidebar__footer class="sidebar__footer ">
	</div>
</div>
